import userService from '@services/user';
import videoReview from '@services/video-review';
// import { RESPONSE_LOGIN_TIMEOUT } from '@configs/constants';
// import { openApp } from '@utils/open-or-download-url';
// import { toLogin } from '@utils/helpers';

interface State {
  isLogin: boolean;
  admin: boolean;
  // 是否是医生
  doctor: boolean;
  userId: number;
  userName: string;
  // 是否同意过协议
  agreeProtocol: boolean;
  doctorVirtualId?: number; // 医生接诊虚拟账号id，当前用户为医生时返回
  doctorVirtualSSecurity?: string; // 医生接诊虚拟账号ssecurity，当前用户为医生时返回
  doctorVirtualST?: string; // 医生接诊虚拟账号token，当前用户为医生时返回
  paymentChannel?: number; // 医生进件通道，0-未完成进件，1-微信已完成进件，2-支付宝已完成进件，3-微信、支付宝均已完成进件
  avatar: string;
  jobType: number | null;
  serviceTypeList: { type: number; name: string; serviceFee: string }[];
  reviewStatus: number; // 医生服务审核状态
  reviewRemark: string; // 审核结果描述
  openServiceStatus: boolean; // 是否开通了服务
  verifiedStatus: boolean; // 认证用户标识
  enablePrivateMsg: boolean; // 是否开通了健康私信服务
  inImV2WhiteList: boolean; // 是否为独立私信的白名单医生
  severableDoctor: boolean; // 是否是开通服务医生（开通了电话咨询 或者 图文咨询）
  enableAuditVideo: boolean; // 是否有视频审核入口
  enableWorkTime: boolean; // 是否有出诊信息配置入口
}

const initState: State = {
  isLogin: false,
  admin: false,
  doctor: false,
  userId: 0,
  userName: '',
  agreeProtocol: false,
  paymentChannel: undefined,
  avatar: '',
  jobType: null,
  serviceTypeList: [],
  reviewStatus: 0,
  reviewRemark: '',
  openServiceStatus: false,
  verifiedStatus: false,
  enablePrivateMsg: false,
  inImV2WhiteList: false,
  severableDoctor: false,
  enableAuditVideo: false,
  enableWorkTime: false
};

const user = {
  state: initState,

  reducers: {
    updateState<K extends keyof State>(
      state: State,
      payload: {
        [key: string]: State[K];
      }
    ): State {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispatch) => ({
    async getUserInfo(cb) {
      // const currentHref = window.location.href;
      try {
        const result = await userService.getUserInfo();
        this.updateState({
          isLogin: true,
          ...result
        });
        cb && cb(result);
        return result;
      } catch (e) {
        this.updateState(initState);
        return Promise.reject(e);
        // 登录异常处理逻辑，暂不启用
        // try {
        //   // 登录过期
        //   const { code } = JSON.parse(e.message);
        //   if (code === RESPONSE_LOGIN_TIMEOUT) {
        //     // 不是快手app内打开
        //     if (openApp()) {
        //       return;
        //     }
        //     toLogin(
        //       async () => {
        //         if (currentHref) {
        //           window.location.href = currentHref;
        //         }
        //       },
        //       () => {
        //         if (currentHref) {
        //           window.location.href = currentHref;
        //         }
        //       }
        //     );
        //   }
        // } catch (error) {
        //   console.error(error);
        // }
      }
    },
    async getAuditEntrance() {
      try {
        const result = await videoReview.getAuditEntrance();
        this.updateState({
          enableAuditVideo: result.enableAuditVideo,
          enableWorkTime: result.enableWorkTime
        });
        return result;
      } catch (e) {
        return Promise.reject(e);
      }
    }
  })
};

export default user;
